module.exports = __webpack_public_path__ + "img/icon_yqwzg.1338aae2.png";